import { render } from "./mainBanner.vue?vue&type=template&id=779af852"
import script from "./mainBanner.vue?vue&type=script&lang=js"
export * from "./mainBanner.vue?vue&type=script&lang=js"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__